import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import type { MigrateVcsGitHubOrgResponse } from '../../../../../shared/types/routes/internalTools/vcsGitHub';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

function migrateVcsGitHubOrg(): Promise<QueryResponse<MigrateVcsGitHubOrgResponse>> {
  return post<Record<string, never>, MigrateVcsGitHubOrgResponse>('/api/internal-tools/vcs-github/migrate', {});
}

/**
 * Enqueues the per-org backfill job migrating the current org's legacy GitHub
 * App projects to vcs-service. Idempotent server-side, so it doubles as
 * re-sync.
 */
export function useMigrateVcsGitHubOrg() {
  return useToastedMutation<QueryResponse<MigrateVcsGitHubOrgResponse>>({
    mutationFn: migrateVcsGitHubOrg,
    successToastMessage: (response) =>
      response.data ? `Migration job queued (task ${response.data.taskId}).` : 'Migration job queued.',
    errorToastMessage: 'Failed to queue the migration job.',
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['internal-tools', 'vcs-github'] });
    },
  });
}
